import { api } from '@smena/ui';

export interface GuestFlags {
  vip?: boolean;
  always_escalate?: boolean;
  do_not_initiate?: boolean;
  blocklist?: boolean;
}

export interface Guest {
  id: string;
  accountId: string;
  name: string | null;
  phone: string | null;
  email: string | null;
  tags: string[];
  flags: GuestFlags;
  createdAt: string;
  updatedAt: string;
}

export interface GuestNote {
  id: string;
  guestId: string;
  authorId: string | null;
  authorName: string | null;
  kind: 'note' | 'instruction';
  text: string;
  createdAt: string;
}

export interface GuestBookingRef {
  id: string;
  checkin: string;
  checkout: string;
  nights: number;
  amount: number;
  status: string;
  source: string;
  propertyId: string;
}

export interface GuestDetail {
  guest: Guest;
  notes: GuestNote[];
  bookings: GuestBookingRef[];
}

export async function fetchGuests(q?: string): Promise<Guest[]> {
  const url = q ? `/api/staff/guests?q=${encodeURIComponent(q)}` : '/api/staff/guests';
  const r = await api<{ items: Guest[] }>(url);
  return r.items;
}

export async function fetchGuest(id: string): Promise<GuestDetail> {
  return api<GuestDetail>(`/api/staff/guests/${id}`);
}

export async function patchGuest(
  id: string,
  patch: Partial<Pick<Guest, 'name' | 'phone' | 'email' | 'tags' | 'flags'>>,
): Promise<Guest> {
  return api<Guest>(`/api/staff/guests/${id}`, { method: 'PATCH', json: patch });
}

export async function createNote(
  id: string,
  data: { kind: 'note' | 'instruction'; text: string },
): Promise<GuestNote> {
  return api<GuestNote>(`/api/staff/guests/${id}/notes`, { method: 'POST', json: data });
}

export async function deleteNote(id: string, noteId: string): Promise<void> {
  await api(`/api/staff/guests/${id}/notes/${noteId}`, { method: 'DELETE' });
}
